module.exports = __webpack_public_path__ + "img/gtt-marine-logo-horizontal--light.74f1ff2f.svg";